import { createSlice } from '@reduxjs/toolkit';
import { getWFjobsId } from 'components/common/Workflow/workflowConfig';

import {
  servicePostJobRun,
  serviceGetJobRun,
  servicePostJobAbort,
  servicePostJobAbortAll,
  serviceGetJobStatus,
  serviceGetJobs,
  // serviceGetJobTail,
  serviceGetJobRunPage,
  serviceGetJobWorkflowDef
} from 'utils';


const preformatJobStatus = (jobStatusContent, jobStatusMap, contentList) => {
  const newContent = contentList;
  let newContentListStatusMap = jobStatusMap;

  jobStatusContent.forEach((job) => {
    const parentIndex = newContentListStatusMap[job.job_id].index;
    const childrenIndex = newContentListStatusMap[job.job_id].subIndex || null;

    if (childrenIndex) {
      newContent[parentIndex].children[childrenIndex].status = job.status;
    } else newContent[parentIndex].status = job.status;

    if (job.status !== 'WA' && job.status !== 'RU') {
      delete newContentListStatusMap[job.job_id];
    }
  });

  return { newContent, newContentListStatusMap };
}

const preformatJobs = (jobContent) => {
  const newContent = [];
  let childrenIndex = 0;
  let parentIndex = 0;
  const contentListStatusMap = {};

  const indexJobMap = jobContent.reduce((previousObject, job) => {
    if (job.worktemplate_wf === 0) {
      if (job.status === 'WA' || job.status === 'RU') {
        contentListStatusMap[job.job_id] = { index: parentIndex };
      }
      newContent.push({
        jobId: job.job_id,
        name: `${job.job_id} - ${job.name}`,
        type:  (job.type_template === 'SI' ? 'jobList.components.table.tags.template' : 'jobList.components.table.tags.workflow'),
        templateType: job.type_template,
        status: job.status,
        children: []
      });
      parentIndex += 1;

      return { [job.job_id]: { parentIndex, childrenIndex: -1 }, ...previousObject };
    } else return { ...previousObject };
  }, {});

  for (let i = jobContent.length - 1; i >= 0; i--) {
    const job = jobContent[i];
    if (job.worktemplate_wf === 0) childrenIndex = 0;

    else if (indexJobMap?.[job.worktemplate_wf]) {
      const childrenJobIndex = { parentIndex: indexJobMap[job.worktemplate_wf].parentIndex, childrenIndex };
      indexJobMap[job.job_id] = childrenJobIndex;

      if (job.status === 'WA' || job.status === 'RU') {
        contentListStatusMap[job.job_id] = { index: childrenJobIndex.parentIndex, subIndex: childrenIndex };
      }

      const parentIndex = childrenJobIndex.parentIndex;
      newContent[parentIndex - 1].children.push({
        jobId: job.job_id,
        name: `${job.job_id} - ${job.name}`,
        type:  (job.type_template === 'SI' ? 'jobList.components.table.tags.template' : 'jobList.components.table.tags.workflow'),
        templateType: job.type_template,
        status: job.status,
        parent: job.worktemplate_wf
      });
      childrenIndex += 1;
    }
  }

  return { newContent, contentListStatusMap};
}

const initialState = {
  data: null,
  contentList: null,
  contentListStatusMap: null,
  isLoaded: {
    post: false,
    postAbort: false,
    get: false,
    getContent: false,
    getStatus: false,
    updateJob: false
  },
  success: {
    post: false,
    postAbort: false,
    get: false,
    getContent: false,
    getStatus: false,
    updateJob: false
  },
  error: {
    post: false,
    postAbort: false,
    get: false,
    getContent: false,
    getStatus: false,
    updateJob: false
  },
}

const JobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    contentListSuccess(state, action) {
      const { newContent, contentListStatusMap } = preformatJobs(action.payload);

      return {
        ...state,
        isLoaded: { ...state.isLoaded, getContent: false },
        success: { ...state.success, getContent: true },
        contentList: newContent || [],
        contentListStatusMap: contentListStatusMap
      };
    },

    statusJobSuccess(state, action) {
      const { newContent, newContentListStatusMap } = preformatJobStatus(
        action.payload,
        {...state.contentListStatusMap},
        [...state.contentList]
      );

      return {
        ...state,
        isLoaded: { ...state.isLoaded, getContent: false },
        success: { ...state.success, getContent: true },
        contentList: newContent || [],
        contentListStatusMap: newContentListStatusMap
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpJob() {
      return initialState;
    },

    cleanUpMessageJob(state) {
      return {
        ...state,
        data: null,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },
  }
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  contentListSuccess,
  statusJobSuccess,
  cleanUpJob,
  cleanUpMessageJob
} = JobSlice.actions;

const fetchGetJobRun = (args) => {
  return (dispatch) => {

    dispatch(dataRequest('get'));
    serviceGetJobRun(args)
      .then((response) => {
          if (response.data.type === 'WF'){
            let jobs = getWFjobsId(response.data.ls_dependencies);
            serviceGetJobWorkflowDef({query:{jobs}}).then((statusList) => {
              response.data.ls_dependencies = updateStatusWF(response.data.ls_dependencies, statusList.data);
              dispatch(dataSuccess({ data: response.data, fetchType: 'get' }));
            });
          }else{
            try{
              const hresult = JSON.parse(response.data.hostresult);
            }catch(err){}

            dispatch(dataSuccess({ data: response.data, fetchType: 'get' }));
          }
        }
      ).catch((err) => dispatch(dataFailure({ data: err, fetchType: 'get' })));
  };
};


const fetchGetNextPage = (args) => {
  return (dispatch) => {
    if (!args.dontLoadMore){
      serviceGetJobRunPage({query: {...args.query, page:args.page }})
        .then((response) => {
              if (!response.data.tail){
                response.data.dontLoadMore = true;
              }

              response.data.tail = response.data.tail + args.currentTail;
              response.data.page = args.page;

              dispatch(dataSuccess({ data: {...response.data,dontHaveToScroll:true}, fetchType: 'get' }));
            
          }
        ).catch((err) => dispatch(dataFailure({ data: err, fetchType: 'get' })));
    };
  }
};




const fetchPostJobRun = (args) => {
  return (dispatch) => {
    dispatch(dataRequest('post'));
    servicePostJobRun(args)
      .then((response) => dispatch(dataSuccess({ data: response.data, fetchType: 'post' })))
      .catch((err) => dispatch(dataFailure({ data: err, fetchType: 'post' })));
  };
};

const fetchPostJobAbort = (args) => {
  return (dispatch) => {
    dispatch(dataRequest('postAbort'));
    servicePostJobAbort(args)
      .then((response) => dispatch(dataSuccess({ data: response.data, fetchType: 'postAbort' })))
      .catch((err) => dispatch(dataFailure({ data: err, fetchType: 'postAbort' })));
  };
};

const fetchPostJobAbortAll = (args) => {
  return (dispatch) => {
    dispatch(dataRequest('postAbort'));
    servicePostJobAbortAll(args)
      .then((response) => dispatch(dataSuccess({ data: response.data, fetchType: 'postAbort' })))
      .catch((err) => dispatch(dataFailure({ data: err, fetchType: 'postAbort' })));
  };
};

const fetchGetContentList = (args) => {
  return (dispatch) => {
    dispatch(dataRequest('getContent'));
    serviceGetJobs(args)
      .then((response) => dispatch(contentListSuccess(response.data)))
      .catch((err) => dispatch(dataFailure({ data: err, fetchType: 'getContent' })));
  };
};

const fetchGetJobStatus = (args) => {
  return (dispatch) => {
    dispatch(dataRequest('getStatus'));
    serviceGetJobStatus(args)
      .then((response) => dispatch(statusJobSuccess(response.data)))
      .catch((err) => dispatch(dataFailure({ data: err, fetchType: 'getStatus' })));
  };
};

const fetchUpdateJobTemplate = (args) => {
  return (dispatch) => {
    dispatch(dataRequest('updateJob'));
    Promise.all([
      serviceGetJobRun(args),
      // serviceGetJobTail(args)
    ])
      .then((response) => {
        // response[0].data.tail = response[0].data.tail;
        dispatch(dataSuccess({ data: response[0].data, fetchType: 'updateJob' }));
      })
      .catch((err) => dispatch(dataFailure({ data: err, fetchType: 'updateJob' })));
  };
};

const fetchUpdateJobWorkflow = (args) => {
  return (dispatch) => {
    dispatch(dataRequest('updateJob'));
    Promise.all([
      serviceGetJobRun(args),
      serviceGetJobWorkflowDef(args)
    ])
      .then((response) => {
        response[0].data['wf_definition'] = response[1].data;
        response[0].data.ls_dependencies = updateStatusWF(response[0].data.ls_dependencies, response[1].data);
        dispatch(dataSuccess({ data: response[0].data, fetchType: 'get' }));

      })
      .catch((err) => dispatch(dataFailure({ data: err, fetchType: 'updateJob' })));
  };
};

const updateStatusWF = (ls_dependencies, lsStatus)=>{
  if (!ls_dependencies || ls_dependencies === "") return []; 
  let wf = [];
  try {
     wf = JSON.parse(ls_dependencies);
  } catch (e) { return [] }

  if(lsStatus && lsStatus.length){
    for (let i=0; i<wf.length;i++){
      const column = wf[i];
      for (let j=0; j<column.length;j++){
        const job = column[j];

        const jobStatus = lsStatus.filter(item=> item.job_id === job.job_id)
        if(jobStatus && jobStatus.length){
          wf[i][j].status = jobStatus[0].status;
          wf[i][j].finish = jobStatus[0].finish
          wf[i][j].start = jobStatus[0].start;
        }
      }
    }
  }

  return wf;
}

export {
  fetchPostJobRun,
  fetchGetJobRun,
  fetchGetNextPage,
  fetchPostJobAbort,
  fetchPostJobAbortAll,
  fetchGetContentList,
  fetchGetJobStatus,
  fetchUpdateJobTemplate,
  fetchUpdateJobWorkflow,
  cleanUpJob,
  cleanUpMessageJob
};

export default JobSlice.reducer;
